import { FC, useContext, useEffect} from "react";
import { APIEndpoints } from "src/types/apiTypes";
import useFetch from "src/hooks/useFetch";
import { downloadExcelFile } from "src/helpers/downloadFile";
import { LoaderContext } from "src/context/loaderContext";
import { AuthContext } from "src/context/authContext";
import { useSearchParams } from "react-router-dom";
import { CopayEnrollmentProps, DownloadPracticeResponseTypeApi, ModalType } from "./types";


const CopayEnrollmnetModal: FC<ModalType> = ({ title, data, startDate, endDate, onClick, drug }): JSX.Element => {
  const { setLoader, hideLoader } = useContext(LoaderContext)
  const {userData} = useContext(AuthContext);
  const [searchParams, updateSearchParams] = useSearchParams();


  const {
    data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadPracticeResponseTypeApi>(APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD);

  useEffect(() => {
    if (downloadReportsData || downloadReportsError) {
      if (downloadReportsData){
        const { response, report_name } = downloadReportsData;
        downloadExcelFile(response, `${report_name}.xlsx`);
      }
      hideLoader();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportsData, downloadReportsError]);


  const downloadReport = () => {
    if (downloadReportsData || downloadReportsError) clearRequestFileData();
    setLoader();
    const params = {
      start_date: startDate,
      end_date: endDate,
      report_name: "copay_enrollment_report",
      role:searchParams.get("role")?.toLowerCase() || userData?.ref_type?.toLowerCase(),
      type:"index",
      id:searchParams.get("userId") || userData?.id,
      drug_id: drug ? (drug === 'iovera' ? 'iovera°' : drug) : ''
    }
    downloadRequestForm({}, {}, params);
  }
  


  const overFlowBackground = () => {
    document.body.style.overflow = 'unset';
  }
  return (
    <div className= {`modal fade loader-index ${title && title.length > 0 ? 'show show-modal' : ''}`} id="typeModal" aria-labelledby="typeModalLabel" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header align-items-md-center align-items-start">
            <div className={"d-block d-md-flex gap-3"}>
              <h3 className="modal-title">{title}</h3>
              <button type="button" className="btn btn-success btn-sm" onClick={() => downloadReport()}>
                Download
              </button>
            </div>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={
              ()=>{
                onClick()
                overFlowBackground()
                }
               }>
               </button>
          </div>
          <div className="modal-body p-0">
            {
              <table className="table table-striped table-hover table-responsive position-relative m-0">
                <thead className="sticky-top">
                  <tr>
                    <th scope="col" className="text-center fs-6">Region</th>
                    <th scope="col" className="text-center fs-6">Territory</th>
                    <th scope="col" className="text-center fs-6">Case ID</th>
                    <th scope="col" className="text-center fs-6">Prescriber First Name</th>
                    <th scope="col" className="text-center fs-6">Prescriber Last Name</th>
                    <th scope="col" className="text-center fs-6">Practice Name</th>
                    <th scope="col" className="text-center fs-6">Enrollment Status</th>
                    <th scope="col" className="text-center fs-6">Enrollment Date</th>
                    <th scope="col" className="text-center fs-6">Enrollment Channel</th>
                    <th scope="col" className="text-center fs-6">Claim Outcome</th>
                    <th scope="col" className="text-center fs-6">Claim Type</th>
                  </tr>
                </thead>
                <tbody>
                  {data &&  data.length > 0 ?
                    data.map((item: CopayEnrollmentProps, index) =>
                      <tr key={index}>
                        <td className="text-center text-wrap">{item.region_name || ""}</td>
                        <td className="text-center text-wrap">{item.territory_name || ""}</td>
                        <td className="text-center text-wrap">{item.case_id || ""}</td>
                        <td className="text-center text-wrap">{item.prescriber_first_name || ""}</td>
                        <td className="text-center text-wrap">{item.prescriber_last_name || ""}</td>
                        <td className="text-center">{item.practice_name}</td>
                        <td className="text-center">{item.enrollment_status}</td>
                        <td className="text-center">{item.enrollment_date}</td>
                        <td className="text-center">{item.enrollment_channel || ""}</td>
                        <td className="text-center">{item.claim_outcome || ""}</td>
                        <td className="text-center">{item.claim_type || ""}</td>


                      </tr>
                    )
                    : null
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
      </div>
    </div>



  );
};

export default CopayEnrollmnetModal;
